import React, { memo, useState } from "react";
import Webhook from "./webhook";
import { Col, Form } from "react-bootstrap";
import { webhookType, webhookTypeName } from "../../../../constants";
import WebhookLogs from "./WebhookLogs";

const Webhooks = ({
    progressions,
    organizationId,
    webhooks,
    webhooksKeyVals,
}) => {
    const [selectedType, setSelectedType] = useState(webhookType.PAYMENT_CLOUD);

    return (
        <>
            <div>
                <Form>
                    <Form.Group
                        as={Col}
                        xs={2}
                        lg={2}
                        className="px-3 modal-pd rev-tier"
                    >
                        <Form.Label>Type</Form.Label>
                    </Form.Group>
                    <Col xs={10} lg={10}>
                        <Form.Group
                            controlId="exampleForm.ControlSelect1"
                            as={Col}
                            xs={11}
                            lg={11}
                        >
                            <Form.Control
                                as="select"
                                name="type"
                                onChange={(e) =>
                                    setSelectedType(e.target.value)
                                }
                            >
                                {Object.values(webhookType).map((t) => (
                                    <option value={t} key={t}>
                                        {webhookTypeName[t]}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Form>
            </div>
            {Object.values(webhookType).map(
                (t) =>
                    selectedType == t && (
                        <Webhook
                            key={t}
                            progressions={progressions}
                            organizationId={organizationId}
                            webhook={webhooks[t] || {}}
                            webhookKeyVals={webhooksKeyVals[t] || {}}
                            type={t}
                        />
                    ),
            )}
            <WebhookLogs organizationId={organizationId} />
        </>
    );
};

Webhooks.defaultProps = {};

export default memo(Webhooks);
